import React from 'react'
import { Modal } from 'antd'
import { ChecklistLogo } from '../../asset';

export default function SuccessModal(props) {
    return (
        <Modal
            centered
            open={props.isOpen}
            onOk={props.onOk}
            closable={props.closable}
            width={props.width}
            className={props.className}
            okText={props.okText}
        >

            <div className="flex flex-col justify-center items-center gap-[9px]">
                <img src={ChecklistLogo} alt="" />
                <div className="flex flex-col justify-center items-center">
                    <h2 className="font-roboto text-3xl font-bold mb-[16px]">{props.title}</h2>
                    <p className="font-roboto text-base text-[#666666] text-center mb-[16px]">{props.description}</p>
                </div>
            </div>

        </Modal>
    )
}
